import { render, staticRenderFns } from "./PortfolioRankings.vue?vue&type=template&id=0b940554&scoped=true"
import script from "./PortfolioRankings.vue?vue&type=script&lang=js"
export * from "./PortfolioRankings.vue?vue&type=script&lang=js"
import style0 from "./PortfolioRankings.vue?vue&type=style&index=0&id=0b940554&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b940554",
  null
  
)

export default component.exports